import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { ProfileStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('profile', reducer),
        EffectsModule.forFeature([ProfileStoreEffects]),
    ],
    providers: [],
})
export class ProfileStoreModule {}
